import { message } from "antd";
export var showError = function showError(error) {
  return message.error({
    content: getErrorMsg(error),
    duration: 5
  });
};
export var showSuccess = function showSuccess(content) {
  return message.success({
    content: content
  });
};

var getErrorMsg = function getErrorMsg(error) {
  var errorMessages = {
    "tatum.not.active.api.key": /*#__PURE__*/React.createElement("div", null, "If you want to work with the Mainnet network you need to have paid API key. If you dont have one, you can buy paid subscription at", " ", /*#__PURE__*/React.createElement("a", {
      href: "https://dashboard.tatum.io",
      target: "_blank",
      rel: "noreferrer"
    }, "Tatum dashboard"), ".")
  };
  var message = errorMessages[error.errorCode];
  return message !== null && message !== void 0 ? message : error.message;
};